<template>
  <div class="container">
    <b-col cols="12">
      <p>
        <strong>INSTRUCCIONES:</strong>
      </p>
      <p id="instruccionesSopa">{{data.instrucciones}}</p>
    </b-col>
    <b-col cols="12" style="text-align: right;">
      <button @click="descargarPdf" class="btn btn-primary">Descargar como PDF</button>
    </b-col>
    <div class="row">
      <b-col lg="12" style="text-align:center;">
        <p
          v-if="generandoSopa"
          style="font-size:18px; font-weight: bold;"
        >Generando Sopa de Letras ...</p>
        <canvas id="lienzo" width="480" height="480"></canvas>
      </b-col>
      <b-col cols="12" style="text-align: center; margin-top:20px;">
        <button @click="solve2" class="btn btn-primary">Mostrar respuestas</button>
      </b-col>
    </div>
  </div>
</template>
<script>
import jsPDF from "jspdf";
import html2canvas from 'html2canvas'

export default {
  name: "pre-sopa",
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          index: null,
          tag: "Sopa",
          palabras: [],
          instrucciones: "",
          data: "",
          size: null
        };
      }
    }
  },
  data() {
    return {
      generandoSopa: true,
      dirx: [
        [1, 0],
        [1, -1],
        [0, -1],
        [-1, -1],
        [-1, 0],
        [-1, 1],
        [0, 1],
        [1, 1]
      ],
      dirs: [
        [0, 0],
        [0.3, 1],
        [0.75, 1],
        [0.35, 0.9],
        [1, 0],
        [0.4, -0.2],
        [0.75, 0],
        [0.35, -0.2]
      ],
      nSize: 25,
      nAlto: 520,
      nAncho: 520,
      palabras: [],
      tablero: [],
      tableroBk: [],
      caracteres: "ABCDEFGHIJKLMNÑOPQRSTUVWXYZ",
      espacio: 24,
      canvas: null,
      lienzo: null,
      listaBk: [],
      palabrasFill: []
    };
  },
  created() {
    this.data.palabras.forEach(el => {
      this.palabrasFill.push(el.text.toUpperCase());
    });
    this.nSize = this.data.size;
    setTimeout(() => {
      this.generandoSopa = false;
      this.generate();
    }, 1000);
  },
  methods: {
    generate() {
      this.canvas = document.getElementById("lienzo");
      this.nAncho = this.nSize * this.espacio + 20;
      this.nAlto = this.nSize * this.espacio + 20;
      this.canvas.setAttribute("width", this.nAncho);
      this.canvas.setAttribute("height", this.nAlto + 110);
      this.lienzo = this.canvas.getContext("2d");
      this.palabras = this.getPalabras().slice(0);
      this.listaBk = [];

      if (this.palabras.length > 0) {
        console.log(this.palabras);
        //Generar Sopa de Letras
        this.initTablero();
        this.distribuir();
        //Dibujar Sopa de Letras Generada
        this.colorFondo();
        this.dibuja();
        this.paintListWords();
      } else {
        console.log("debes ingresar por lo menos una palabra");
      }
    },
    getPalabras() {
      return this.palabrasFill;
    },
    initTablero() {
      for (var i = 0; i < this.nAlto; i++) {
        this.tablero[i] = [];
        for (var j = 0; j < this.nAncho; j++) {
          this.tablero[i][j] = "*";
        }
      }
    },
    distribuir() {
      for (var i = 0; i < this.palabras.length; i++) {
        var x = parseInt(Math.floor(Math.random() * this.nSize));
        var y = parseInt(Math.floor(Math.random() * this.nSize));
        var r = parseInt(Math.floor(Math.random() * 8));

        if (this.valida(this.palabras[i], x, y, this.dirx[r])) {
          this.listaBk.push([x, y, this.dirx[r]]);
          this.insertar(this.palabras[i], x, y, this.dirx[r]);
        } else {
          i--;
        }
      }
    },
    insertar(palabra, xi, yi, dir) {
      for (var i = 0; i < palabra.length; i++)
        this.tablero[xi + i * dir[0]][yi + i * dir[1]] = palabra.charAt(i);
    },
    colorFondo() {
      //Fondo
      this.lienzo.beginPath();
      this.lienzo.fillStyle = "#FFF";
      this.lienzo.fillRect(0, 0, this.nAncho, this.nAlto + 110);
      this.lienzo.closePath();
      this.lienzo.fill();

      //Borde
      this.lienzo.beginPath();
      this.lienzo.strokeStyle = "#000";
      this.lienzo.strokeRect(0, 0, this.nAncho, this.nAlto + 110);
      this.lienzo.closePath();
      this.lienzo.fill();
    },
    dibuja() {
      var len = this.caracteres.length;
      for (var i = 0; i < this.nSize; i++) {
        this.tableroBk[i] = [];
        for (var j = 0; j < this.nSize; j++) {
          var tmp;
          if (this.tablero[i][j] == "*") {
            tmp = this.caracteres.charAt(
              parseInt(Math.floor(Math.random() * len))
            );
          } else {
            tmp = this.tablero[i][j];
          }

          this.tableroBk[i][j] = tmp;

          this.lienzo.beginPath();
          this.lienzo.font = "13pt Tahoma";
          this.lienzo.fillStyle = "#000";
          this.lienzo.fillText(
            tmp,
            15 + i * this.espacio,
            30 + j * this.espacio
          );
          this.lienzo.closePath();
          this.lienzo.fill();
        }
      }
    },
    paintListWords() {
      this.lienzo.beginPath();
      this.lienzo.fillRect(10, this.nAlto - 5, this.nAncho - 20, 10);
      this.lienzo.closePath();

      var col = 0;
      var row = 0;

      for (var i = 1; i <= this.palabras.length; i++) {
        this.lienzo.beginPath();
        this.lienzo.font = "10pt Tahoma";
        this.lienzo.fillText(
          this.palabras[i - 1],
          10 + col * 150,
          this.nAlto + 20 * row + this.espacio
        );
        this.lienzo.closePath();
        this.lienzo.fill();
        row++;
        if (i % 5 === 0) {
          col++;
          row = 0;
        }
      }
    },
    valida(palabra, xi, yi, dir) {
      var len = palabra.length;
      var lReturn = false;

      if (
        xi + len * dir[0] > 0 &&
        xi + len * dir[0] < this.nSize &&
        yi + len * dir[1] > 0 &&
        yi + len * dir[1] < this.nSize
      ) {
        for (var i = 0; i < len; i++) {
          if (
            this.tablero[xi + i * dir[0]][yi + i * dir[1]] == "*" ||
            this.tablero[xi + i * dir[0]][yi + i * dir[1]] == palabra.charAt(i)
          ) {
            lReturn = true;
          } else {
            lReturn = false;
            break;
          }
        }
      } else {
        lReturn = false;
      }

      return lReturn;
    },
    solve2() {
      for (var i = 0; i < this.listaBk.length; i++) {
        var ix = this.equiv(this.listaBk[i][2]);
        this.rectangulo(
          this.lienzo,
          11 +
            this.listaBk[i][0] * this.espacio +
            this.dirs[ix][0] * this.espacio,
          15 +
            this.listaBk[i][1] * this.espacio +
            this.dirs[ix][1] * this.espacio,
          this.palabras[i].length * this.espacio * this.listaBk[i][2][0],
          this.palabras[i].length * this.espacio * this.listaBk[i][2][1],
          18,
          this.listaBk[i][2][0],
          this.listaBk[i][2][1]
        );
      }
    },
    equiv(dir) {
      var ix = 0;
      for (var i = 0; i < this.dirx.length; i++) {
        if (this.dirx[i][0] === dir[0] && this.dirx[i][1] === dir[1]) {
          ix = i;
          break;
        }
      }
      return ix;
    },
    rectangulo(ctx, xi, yi, x, y, h, a, b) {
      var alfa;
      if (Math.abs(a) + Math.abs(b) == 2) {
        alfa = Math.PI / 4;
        x *= 0.92;
        y *= 0.92;
      } else {
        if (Math.abs(a) == 1) {
          alfa = Math.PI / 2;
        } else if (Math.abs(b) == 1) {
          alfa = 0;
        }
      }

      ctx.beginPath();
      ctx.strokeStyle = "rgba(255, 0, 0, 0.5)";
      ctx.fillStyle = "rgba(255, 255, 0, 0.25)";
      ctx.moveTo(xi, yi);
      ctx.lineTo(xi + x, yi + y);
      ctx.lineTo(
        xi + x - (a === 0 ? 1 : a) * h * Math.cos(alfa),
        yi + y + (b === 0 ? 1 : b) * h * Math.sin(alfa)
      );
      ctx.lineTo(
        xi - (a === 0 ? 1 : a) * h * Math.cos(alfa),
        yi + (b === 0 ? 1 : b) * h * Math.sin(alfa)
      );
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
    },
    descargarPdf() {
      var canvas = document.getElementById("lienzo");
      var imgData = canvas.toDataURL("image/jpeg", 1.0);
      var pdf = new jsPDF("p", "mm", "a4");
      var width = pdf.internal.pageSize.getWidth() - 20;
      var height = pdf.internal.pageSize.getHeight() - 70;
      pdf.setFontSize(16);
      pdf.text(10, 10, "INSTRUCCIONES");
      pdf.setFontSize(12);
      pdf.text(10, 20, this.data.instrucciones);
      pdf.addImage(imgData, "JPEG", 10, 30, width, height);
      pdf.save("download.pdf");
    }
  }
};
</script>
<style scoped>
</style>